var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconF1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 71",
    enableBackground: "new 0 0 77 71",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 37,
    fill: "#1184A2",
    width: 36.7,
    height: 25.7
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 21.3,
    y1: 39,
    x2: 8.6,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 56.6,
    y1: 39,
    x2: 69.3,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1184A2",
    d: "M39.9,6.3l3.2,6.4c0.2,0.5,0.7,0.8,1.3,0.9l7.1,1c1.4,0.2,2,1.9,0.9,2.9l-5.1,5c-0.4,0.4-0.6,1-0.5,1.5 l1.2,7.1c0.2,1.4-1.2,2.4-2.5,1.8l-6.3-3.3c-0.5-0.3-1.1-0.3-1.6,0L31.3,33c-1.2,0.7-2.7-0.4-2.5-1.8l1.2-7.1 c0.1-0.6-0.1-1.1-0.5-1.5l-5.1-5c-1-1-0.5-2.7,0.9-2.9l7.1-1c0.6-0.1,1-0.4,1.3-0.9l3.2-6.4C37.5,5.1,39.3,5.1,39.9,6.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 34.3,20.5 37.9,23.9 44,17.6  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconF1);
export default __webpack_public_path__ + "static/media/icon-f-1.e6031af6cc30e458457bdf6c45138ef4.svg";
export { ForwardRef as ReactComponent };